import React, { useEffect, useState, useRef } from "react";
import { useTabs } from "../hooks/useTabs";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { InfoIcon } from "../utils/Icons";
import Button from "../ui/Button";


export default function PrintOrderActivity(props) {
    const { controller = "", callback = () => { }, route = "" } = props;

    const defaultTabs = [
        { label: "From:", key: "from", value: "" },
        { label: "To:", key: "to", value: "" },
        { label: "Customer PO#:", key: "customer_po", value: "" },
        { label: "Sort by:", key: "sort_by", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "from");

    const sortByOptions = [
        { value: "date", label: "Date" },
        { value: "customer_po", label: "Customer PO#" },
        { value: "title", label: "Title" },
        { value: "author", label: "Author" },
        { value: "supplier", label: "Supplier" },
    ]

    useEffect(() => {
        const el = refs?.current?.[index];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
        const actions = [
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            { key: KBD.ESCAPE, action: () => { callback(false) } },
        ]
        const cleanup = listen(controller, route, actions, false, [KBD.ENTER, KBD.ESCAPE, KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [index])


    return (
        <div style={{ "width": "500px"}}>
            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "from") ? "selected" : ""} width={100}>From:</Label>
                <Input autoselect maxLength={50} {...editProps("from")} className={(index !== "from") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "to") ? "selected" : ""} width={100}>To:</Label>
                <Input autoselect maxLength={50} {...editProps("to")} className={(index !== "to") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "customer_po") ? "selected" : ""} width={100}>Customer PO#:</Label>
                <Input autoselect maxLength={50} {...editProps("customer_po")} className={(index !== "customer_po") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "sort_by") ? "selected" : ""} width={100}>Sort by:</Label>
                <Input autoselect maxLength={50} {...editProps("sort_by")} className={(index !== "sort_by") ? "dim" : ""} placeholder="" width={150} />
            </Space>
            <Space height={50} size={10}>
                <Button type="primary" style={{"marginLeft": "110px"}}>Generate Report [pgdn]</Button>
            </Space>
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon />[enter] to Change option. [pgdn] to generate report. </Status>
        </div>
    )
}